import { Link } from "react-router-dom";

export default function ContinentsSection() {
  const countries = [
    { name: "Americas", image: "/images/america-flag.png" },
    { name: "Europe", image: "/images/europe_flag.png" },
    { name: "ANZ", image: "/images/anz-flag.png" },
    { name: "Middle East", image: "/images/middle-flag.png" },
    { name: "Asia Pacific", image: "/images/apac-flag.png" },
    { name: "Africa", image: "/images/africa-flag.png" },
  ];

  const regionIds = {
    "Asia Pacific": "Asia_Pacific",
    "Middle East": "Middle_East",
    Africa: "Africas",
  };

  const getRegionParam = (name) => regionIds[name] || name;

  return (
    <section id="continents" className="continents-section scroll-mt-24">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8 mb-md-10 mb-lg-12 text-white">
          <h2 className="text-3xl text-md-4xl text-lg-5xl font-bold mb-2 mb-md-3" style={{ fontSize: 'clamp(1.75rem, 5vw, 3rem)', lineHeight: '1.2' }}>
            Creating Futures across 5<br className="d-none d-md-block" />
            <span className="d-md-none"> </span>continents
          </h2>
          <p className="text-base text-md-lg text-cyan-100" style={{ fontSize: 'clamp(0.95rem, 2vw, 1.125rem)', lineHeight: '1.6' }}>
            Connect with our talent and recruitment experts around the world
          </p>
        </div>

        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-3">
          {countries.map((country) => (
            <div className="col" key={country.name}>
              <Link
                to={`/contact-us?global=${encodeURIComponent(getRegionParam(country.name))}`}
                className="continent-pill w-100"
                aria-label={`View ${country.name} contacts`}
              >
                <div className="continent-flag">
                  <img src={country.image} alt={`${country.name} flag`} />
                </div>
                <span className="continent-name">{country.name}</span>
                <span className="continent-arrow">→</span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

